import type { UseQueryOptions } from "react-query";
import { useQuery } from "react-query";

import { useApiClient } from "api/useApiClient";

import type { Lesson } from "../schemas/lessons";

const queryKeyPrefix = "getLesson";
type QueryKey = [typeof queryKeyPrefix, number];
const getLessonQueryKey = (lessonID: number): QueryKey => [queryKeyPrefix, lessonID];

export const useGetLesson = (lessonID: number, options?: UseQueryOptions<Lesson, Error, Lesson, QueryKey>) => {
  const client = useApiClient();

  return useQuery(getLessonQueryKey(lessonID), () => client.getLesson(lessonID), options);
};
